import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import InfoPage from './InfoPage/InfoPage'
import Alert from './Alert/Modal'
import Toolbar from '../Author/Toolbar/Toolbar'
import {isEmpty, cloneDeep} from "lodash"
import CircularProgress from '@material-ui/core/CircularProgress';
import AttachmentRenderer from '../Author/AttachmentsDisplay/AttachmentRenderer'
import StepActionsToolBar from '../Author/StepActionsToolbar/StepActionsToolbar'
import StepContent from '../Author/StepContent/StepContent'
// import NavigationButtons from './NavigationButtons'
import { exitPreview } from '../../../Templates/icons'
import AttachmentsList from './AttachmentsList'
import AlertsList from './AlertsList'
import {getFlatDataFromTree} from 'react-sortable-tree'
import Dialogue from '../../../Templates/Dialogue'

class WIPreview extends Component {
    constructor(props){
        super()

        this.state = {
            noWorkInstruction: true,
            warningsRead: false,
            stepWarningsRead: false,
            currentStepIndex: 0,
            attachmentIndex: 0,
            displayingContent: true,
            displayingAlerts: false,
            displayingAttachments: false,
            displayingTOC: false,
            unityContextRef:null,
            verificationArray:[],
            requiresOversight: false,
            requiresVerification: false,
            
        }

    }

    componentDidMount = () => {
        this.props.previewWorkInstruction().then(
            async res => {
                let wi = res.workInstruction
                let flatSteps = await getFlatDataFromTree({
                    treeData: wi.steps,
                    getNodeKey: (({ node }) => node._id),
                    ignoreCollapsed: false,
                }).map(node => {
                    node.parentNode = node.path[node.path.length - 2]
                    return node
                });
                let currentStep = wi.steps[0]
                let infoPage = typeof wi.info_page === "string" ? JSON.parse(wi.info_page) : wi.info_page
                if(!currentStep.requiresOversight && !currentStep.verifyVerification) {
                    let verificationArray = cloneDeep(this.state.verificationArray)
                    let verificationObj = {step: 0, verified: true} 
                    verificationArray.push(verificationObj)
                    this.setState({verificationArray})
                }
                this.setState({
                    noWorkInstruction: false,
                    workInstruction: wi,
                    currentStep: currentStep,
                    currentStepIndex: 0,
                    requiresOversight: currentStep.requiresOversight,
                    requiresVerification: currentStep.requiresVerification,
                    release: wi.release,
                    currentStepInfoItems: this.buildInfoItems(infoPage, currentStep._id),
                    viewingAttachment: false,
                    flatSteps
                })
            }
        )
    }

    updateCurrentStepIndex = (currentStepIndex, currentStep) => {
        if (!currentStep) {
            let steps = this.state.flatSteps
            currentStep = steps[currentStepIndex].node
        }
        let requiresVerification = false
        {this.state.currentStepIndex < currentStepIndex  && !this.checkIfVerified() ? requiresVerification = true: requiresVerification = false}
        let displayingVerificationPrompt = requiresVerification
        if(requiresVerification){
           console.log(this.state)
            this.setState({                         
                requiresOversight: this.state.requiresOversight ,
                requiresVerification: this.state.requiresVerification
                            
            })
        }else{
            let infoPage = this.props.workInstruction.info_page
            if(!currentStep.requiresOversight && !currentStep.verifyVerification) {
                let verificationArray = cloneDeep(this.state.verificationArray)
                let verificationObj = {step: currentStepIndex, verified: true} 
                verificationArray.push(verificationObj)
                this.setState({verificationArray})
            }
            infoPage = typeof infoPage=== "string" ? JSON.parse(infoPage) : infoPage
            this.setState({ 
                currentStepIndex, 
                currentStep, 
                currentStepInfoItems: this.buildInfoItems(infoPage, currentStep._id),
                stepWarningsRead: false, 
                requiresOversight: currentStep.requiresOversight,
                requiresVerification: currentStep.verifyVerification,
                displayingVerificationPrompt,
                viewingAttachment: "",
                displayingContent: true,
                displayingAttachments: false,
                displayingAlerts: false,
            })
        }
    }

    oversightVerification = () => { 
     let username = document.getElementById("username-input").value;
     let password = document.getElementById("password").value;
     let errorDiv = document.getElementById("VerificationErrorDiv");
     errorDiv.hidden = true
     if (typeof username !== "undefined" && typeof password !== "undefined" && username.trim().length !== 0 && password.trim().length !== 0)      
         {
             let creds = {username: username,
                 password: password }            
          this.props.oversightVerficiation(creds).then( async  res=>{ 
                 let verificationArray = cloneDeep(this.state.verificationArray)
              if(this.props.verifySupervisor.success){
                  let verificationObj = {step: this.state.currentStepIndex, verified: true}                
                  verificationArray.push(verificationObj)  
                  this.setState({requiresOversight: false})  
                  this.updateCurrentStepIndex(this.state.currentStepIndex + 1,true)        
              }else{
                let verificationObj = {step: this.state.currentStepIndex, verified: false}               
                verificationArray.push(verificationObj)
                errorDiv.hidden = false
                errorDiv.innerHTML= `<p>${this.props.verifySupervisor.message}</p>`
              }  
              this.setState({verificationArray: verificationArray})                 
                })
           
         }

    }

    storeColor = () =>{
        console.log("color stored")

    }

    closeVerificationInput =() =>{
        let verificationArray = this.state.verificationArray
        let verificationObj = {step: this.state.currentStepIndex, verified: false}
        if (verificationArray.length === 0){
            verificationArray.push(verificationObj)
        }
        else{
            verificationArray.forEach(obj =>{
                if (obj.step === this.state.currentStepIndex){
                    obj.verified = false
                }           
            })
        }
        this.setState({verificationArray: verificationArray})
        
    }

    setVerificationDialog = () =>{
        return <Dialogue
       alert={this.returnVerificationInput()}
        buttonAttr ={'style={color:"red"}'}
        confirmAction = {this.oversightVerification}
        onlyConfirmation={false}
        buttonText = {"Authorize"}
        cancel={this.closeVerificationInput} /> 
    }

    updateUnityContext =(context) =>{
        this.setState({unityContextRef: context})
    }

    buildInfoItems = (infoPage, stepId) => {
        let currentStepInfoItems = {}
        if (!isEmpty(infoPage)) {
            for (const [infoItem, infoObject] of Object.entries(infoPage)) {
                if (infoObject.steps.includes(stepId)) {
                    if (!currentStepInfoItems[infoObject.category]) {
                        currentStepInfoItems[infoObject.category] = []
                    }
                    currentStepInfoItems[infoObject.category].push(infoItem)
                }
            }
        }
        return currentStepInfoItems
    }

    checkForButtonClick = (e) => {
        e.stopPropagation()
        if (e.target.localName === "button") { 
            let fileName = e.target.innerText
            this.viewAttachment(fileName)
        }
    }

    renderStepViewer = (currentStep) => {
        if ((currentStep.attachments && currentStep.attachments.length > 0) || this.state.viewingAttachment) {
                return <AttachmentRenderer
                    height="100%"
                    fromPreview={true}
                    attachmentIndex={this.state.attachmentIndex}
                    setAttachmentIndex={(value) => this.setState({ attachmentIndex: value, viewingAttachment: "" })}
                    updateColor={this.storeColor}
                    storeCameraData={this.storeCameraData}
                    attachments={currentStep.attachments}
                    currentStep={this.state.currentStep}
                    steps={this.props.workInstruction.steps}
                    checkForButtonClick={this.checkForButtonClick}
                    updateCurrentStepIndex={this.updateCurrentStepIndex}
                    path={this.state.path}
                    currentStepIndex={this.state.currentStepIndex}
                    infoItems={this.state.infoItems}
                    currentStepInfoItems={this.state.currentStepInfoItems}
                    viewAttachment={this.viewAttachment}
                    displayingTOC={this.state.displayingTOC}
                    toggleTOC={() => this.setState(prevState => ({displayingTOC: !prevState.displayingTOC}))}
                    viewingAttachment={this.state.viewingAttachment}
                    updateToggleAnnotation ={this.updateToggleAnnotation}
                    unityContextRef = {this.state.unityContextRef}
                    updateUnityContext={this.updateUnityContext}
                    />
            } else {
                return <div id="wi-preview-notice-container" className="flex-column-centered max-width">
                    <div id="wi-preview-notice-label">
                        This step does not contain attachments.
                    </div>
                </div>

        }
    }

    renderAlerts = (infoItems) => {
        let warnings = infoItems["Warnings"]
        let cautions = infoItems["Cautions"]
        if ((warnings || cautions) && !this.state.stepWarningsRead) {
            return <Alert warnings={warnings} cautions={cautions} closeModal={() => this.setState({ stepWarningsRead: true })} />
        } 
    }
    
    viewAttachment = (filename) => {
        if (this.state.viewingAttachment === filename) {
            this.setState({
                viewingAttachment: ""
            })
        } else {
            this.setState({
                viewingAttachment: filename
            })
        }
    }
    getSelectedAnnotation = () => {
        return this.state.selectedAnnotation
    }
    returnVerificationInput = () =>{
        return <div id="login-form-preview" className="flex-column" style={{height: "6em"}}>
                    <span>Please enter supervisor credentials</span>
                    <div className="input-box shadow"><input id="username-input" type="type" autocomplete="none"  placeholder="Supervisor Username"></input></div>
                    <div className="input-box shadow"><input id="password" type="type" autocomplete="none" placeholder="Supervisor Password"></input></div>
                    <div id="VerificationErrorDiv" style={{color:"red"}}hidden></div>
                </div>
    }

    checkIfVerified = () =>{
        let verificationArray = this.state.verificationArray
        if (verificationArray.length === 0){
            console.log("no objs in verification array")
            return false
        }
        let check = false
        verificationArray.forEach(obj =>{
            console.log(`${verificationArray.length} objs in verification array`)
            if (obj.step === this.state.currentStepIndex){
                check = obj.verified
                console.log(`1 object matched index`)
            }           
        })
        console.log(`returning ${check} for verification `)
        return check

    }

    render() {
        const workInstruction = this.props.workInstruction
        return this.state.noWorkInstruction ? 
            <div className="flex-column-centered max-height">
                <CircularProgress />
            </div>
                : 
            <Fragment>
                <div id="wi-preview-view-window" className="max-width" style={{height: "calc(100% - 47px)"}}>

                {this.state.warningsRead && (this.state.requiresOversight || this.state.requiresVerification) && !this.checkIfVerified()? this.setVerificationDialog(): null}

                {/* {this.state.displayingVerificationPrompt && this.state.currentStepIndex > 0 && !this.checkIfVerified()? setVerificationDialog : null} */}

                <Toolbar workInstruction={this.props.workInstruction} WITitle={workInstruction.title || ""} fromPreview={true} nullOptions />
                {this.state.warningsRead ? 
                    <div id="wi-preview-container" className="flex">
                        
                            <div id="wi-author-header" className="flex-apart flex-align-center max-width">
                                <h3 style={{color: "white"}}>{workInstruction.title || ""}</h3>
                                {exitPreview(() => this.props.history.goBack())}
                            </div> 
                        <div className="flex-child" style={{height: "calc(100% - 25px)"}}>  
                            {this.renderStepViewer(this.state.currentStep)}
                            {this.renderAlerts(this.state.currentStepInfoItems)}
                            
                        </div>
                        <div className="flex-child" style={{height:"calc(100% - 25px)"}}>    
                            {this.state.displayingContent ? 
                                <StepContent
                                    selectedStep={this.state.currentStep ? this.state.currentStep : undefined}
                                    fromPreview={true}
                                    attachments={this.state.currentStep ? this.state.currentStep.attachments : []}
                                    getSelectedAnnotation={this.getSelectedAnnotation}
                                /> : null} 
                            {this.state.displayingAttachments ? 
                                <AttachmentsList 
                                attachments={this.state.currentStep.attachments || []}
                                viewAttachment={this.viewAttachment}
                                viewingAttachment={this.state.viewingAttachment}
                                /> : null}
                            {this.state.displayingAlerts ? 
                                <AlertsList infoItems={this.state.currentStepInfoItems}
                                    displayingInfoItemsList={this.state.displayingInfoItemsList} 
                                /> : null}
                            {/*  <NavigationButtons 
                                    flatSteps={this.state.flatSteps} 
                                    fromPreview = {true}
                                    currentStepIndex={this.state.currentStepIndex}
                                    moveStep={this.updateCurrentStepIndex}    
                                    exitPreview={() => this.props.history.goBack()}
                                /> */}
                                                                                
                           <StepActionsToolBar
                                selectedStep={this.state.currentStep ? this.state.currentStep : null}
                                steps={this.state.steps}
                                fromPreview={true}
                                displayingContent={this.state.displayingContent}
                                displayingTOC={this.state.displayingTOC}
                                toggleTOC={() => this.setState(prevState => ({displayingTOC: !prevState.displayingTOC}))}
                                toggleStepContent={() => this.setState({ displayingContent: true, displayingAlerts: false, displayingAttachments: false})}
                                infoPage={this.state.infoPage && !isEmpty(this.state.infoPage) ? this.state.infoPage : null}
                                toggleStepAlerts={() => this.setState({ displayingAlerts: true, displayingContent: false, displayingAttachments: false})}
                                displayingAlerts={this.state.displayingAlerts}
                                toggleAttachments={() => this.setState({ displayingAttachments: true, displayingContent: false, displayingAlerts: false})}
                                displayAttachments ={this.state.displayingAttachments}
                                toggleStepRequirement={this.toggleStepRequirement}
                                flatSteps={this.state.flatSteps} 
                                currentStepIndex={this.state.currentStepIndex} 
                                moveStep={this.updateCurrentStepIndex}      
                                checkIfVerified = {this.checkIfVerified}                         
                            />
                        </div>
                    </div>
                        : 
                    <InfoPage
                        workInstruction={workInstruction}
                        infoPage={this.state.infoPage}
                        confirmWarnings={() => this.setState({ warningsRead: true })}
                        requireInfoChecks={workInstruction.require_info_checks}
                    />}
                </div>
            
            </Fragment>
    }
}

export default withRouter(WIPreview)